import { Image, Skeleton, Swiper, SwiperRef } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import img from 'app/img';
import PlaceholderImg from 'components/dot/placeholder-img';
import { useI18n } from 'i18n/useI18n';
import { useRef } from 'react';
import { AiFillLeftSquare, AiFillRightSquare } from 'react-icons/ai';

const Carousel = (data: { showBtn: boolean; height?: number }) => {
  const carousel = [
    { uuid: 1, carouselUrl: img.ad, carouselLink: '/' },
    { uuid: 2, carouselUrl: img.ad, carouselLink: '/' },
    { uuid: 3, carouselUrl: img.ad, carouselLink: '/' },
  ];
  const ref = useRef<SwiperRef>(null);

  const items = carousel.map((item, index) => (
    <Swiper.Item key={item.uuid}>
      <Image
        src={item.carouselUrl}
        fit="cover"
        height={data.height}
        placeholder={
          <div
            style={{ height: data.height }}
            className=" object-cover"
          />
        }
        fallback={
          <div
            style={{ height: data.height }}
            className=" object-cover"
          />
        }
        style={{ minHeight: data.height }}
        onClick={() => window.open(item.carouselLink, '_target')}
      />
    </Swiper.Item>
  ));

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Swiper
          autoplay
          allowTouchMove
          autoplayInterval={8000}
          loop
          ref={ref}
          indicator={() => null}
          indicatorProps={{
            color: 'white',
            style: {
              '--active-dot-color': 'orange', //当前元素圆点颜色
              '--dot-border-radius': '50%', //元素圆点圆角值
              '--active-dot-border-radius': '12px', //当前元素圆点的圆角值
              '--active-dot-size': '12px', //元素圆点的大小
              '--dot-color': '#666', //元素圆点的颜色
              '--dot-size': '12px', //元素圆点的大小
              '--dot-spacing': '12px', //圆点与圆点之前的距离
            },
          }}
          defaultIndex={0}
        >
          {items}
        </Swiper>
        {data.showBtn && (
          <>
            <div>
              <div
                style={{
                  position: 'absolute',
                  left: 15,
                  top: '47%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  ref.current?.swipePrev();
                }}
              >
                <AiFillLeftSquare style={{ fontSize: 30, color: '#eee' }} />
              </div>
              <div
                style={{
                  position: 'absolute',
                  right: 15,
                  top: '47%',
                  cursor: 'pointer',
                }}
                onClick={(() => {
                  ref.current?.swipeNext();
                })}
              >
                <AiFillRightSquare style={{ fontSize: 30, color: '#eee' }} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Carousel;
